import { CTAFormSection } from 'components/formSections/CTAFormSection';
import Banner from 'components/Banner';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import headOfficePin from 'images/icons/headOfficePin.svg';
import aboutUsBanner from 'images/aboutUsBanner.jpg';
import EuropeFlag from 'images/small-images-inside-text/EuropeFlag.jpg';
import GermanFlag from 'images/small-images-inside-text/GermanFlag.jpg';
import headOffice from 'images/headOffice.jpg';
import './styles.scss';
import TeamSection from './TeamSection';
import teamPhoto from 'images/team.jpg';
import MissionAndValuesSection from 'components/MissionAndValuesSection';
import { aboutUsData } from 'components/MissionAndValuesSection/mockData';
import OurHistory from './OurHistory';

const AboutUs = () => {
    return (
        // TODO: FIX LEFT-RIGHT OFFSETS
        <div className="container">
            <Banner image={aboutUsBanner} buttonText="Learn more">
                <GradientText size="middle" textColor="white">
                    Climate is <em>changing</em>. <br />
                    We’re <em>changing</em> faster.
                </GradientText>
            </Banner>

            <div className="main-text-container">
                <LabelButton>about uniferx</LabelButton>
                <GradientText>
                    A family business philosophy{' '}
                    <em>
                        born in <img src={EuropeFlag} alt="decor" /> Europe
                    </em>
                    , with solutions{' '}
                    <em>
                        made in <img src={GermanFlag} alt="decor" /> Germany
                    </em>
                </GradientText>
                <div className="offset-left-4 max-width-760">
                    <GradientText size="small">
                        We love "X" because "X" is the symbol of the unknown in a scientific formula.{' '}
                        <em>We offer excellent products and technologies for agriculture</em> that benefit farmers and
                        are in harmony with nature and people.
                    </GradientText>
                </div>
            </div>

            <div className="head-office">
                {/* TODO: adjust this section  */}
                <div className="head-office__left">
                    <img src={headOfficePin} alt="icon pin" />
                    <GradientText size="small">
                        <em>Our head office is located in Nienhagen</em>, near the city of Rostock: more than 800 years
                        later, it was the gateway to trade with Eastern Europe.
                    </GradientText>
                </div>
                <img src={headOffice} alt="head office" className="head-office__right" />
            </div>

            <MissionAndValuesSection data={aboutUsData} />

            <TeamSection />

            <OurHistory />

            <div className="about-us-photo">
                <img src={teamPhoto} alt="" />
            </div>

            <CTAFormSection />
        </div>
    );
};
export default AboutUs;
